import { FormattedMessage } from 'react-intl';
import React from 'react';
import GiftCard1 from 'components/GiftCard1';
import * as styles from './styles/styles.module.scss';

const RedemptionHeader = () => (
  <main className={styles.heroContainer}>
    <div className={styles.contentContainer}>
      <h1 className={styles.heroMessage}>
        <FormattedMessage defaultMessage="Redeem your <span>gift subscription.</span>" values={{ span: (chunks: string) => <span>{chunks}</span> }} />
      </h1>
      <div className={styles.giftCards}>
        <GiftCard1 />
      </div>
    </div>
  </main>
);

export default RedemptionHeader;
